import { getRemoteConfigVariantData } from 'nove8/helpers/getRemoteConfigVariantData'
import {
  Countries,
  FirebaseRemoteConfigKey,
  TestGroup,
  LOCALES,
  WOOFZ_22_V4,
} from 'root-constants'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandStore } from 'zustandGlobalStore'

export const isRoverPartnership2UpsellEnabled = (): boolean => {
  const {
    firebaseRemoteConfig,
    lead,
    initialCohort,
  } = useZustandStore.getState()
  const cohort = lead?.cohort || initialCohort
  const { language } = useZustandSessionStore.getState()
  const country = lead?.country

  if (
    cohort !== WOOFZ_22_V4 ||
    language !== LOCALES.EN ||
    country !== Countries.US
  ) {
    return false
  }

  const segment = getRemoteConfigVariantData({
    firebaseRemoteConfig,
    firebaseRemoteConfigKey:
      FirebaseRemoteConfigKey.ABTEST_WEB_2674_ROVER_PARTNERSHIP2,
  })

  return segment?.toString() === TestGroup.ABTEST_WEB_2674_B_ROVER_PROMO
}
